import { UntypedFormControl } from '@angular/forms';

export class MarketingModel {
  name: UntypedFormControl;
  code: UntypedFormControl;
  reference: UntypedFormControl;
  value: UntypedFormControl;
  subCodeReference?: UntypedFormControl;
  type?: UntypedFormControl;
}
